<template>
  <section>
    <nav class="columns">
      <div class="column">
        <b-field grouped group-multiline>
          <b-field>
            <b-input
              v-model="searchName"
              :placeholder="$t('attributes.search') + $t('attributes.name')"
              type="search"
              icon="magnify"
              @input="onSearch"
            ></b-input>
          </b-field>
        </b-field>
      </div>
      <div class="column is-3 is-2-desktop">
        <div class="buttons is-right">
          <b-button
            :loading="isLoading"
            class="is-primary"
            icon-left="plus"
            @click="onAdd"
          >
            <span>
              {{ $t('attributes.add') + $t('attributes.attribute') }}
            </span>
          </b-button>
        </div>
      </div>
    </nav>
    <b-table
      :data="attributes"
      ref="table"
      paginated
      per-page="10"
      detailed
      detail-key="name"
      @details-open="row => showDetail(row)"
      :show-detail-icon="true"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
      <b-table-column field="id" :label="$t('attributes.id')" v-slot="props">
        {{ props.row.id }}
      </b-table-column>
      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        v-slot="props"
      >
        {{ props.row.name }}
      </b-table-column>
      <b-table-column
        field="created_at"
        :label="$t('attributes.create_date')"
        v-slot="props"
      >
        {{ formatDateTime(props.row.created_at) }}
      </b-table-column>
      <b-table-column
        field="updated_at"
        :label="$t('attributes.modify_date')"
        v-slot="props"
      >
        {{ formatDateTime(props.row.updated_at) }}
      </b-table-column>
      <b-table-column :width="80" label="功能" centered v-slot="props">
        <div class="buttons">
          <b-button type="is-primary" @click.prevent="onModify(props.row)">
            {{ $t('attributes.modify') }}
          </b-button>
        </div>
      </b-table-column>
      <template #detail="props">
        <article class="media">
          <attributes-relation-list :attribute="props.row" />
        </article>
      </template>
    </b-table>
    <b-modal
      :active.sync="isFormModalActive"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <attributes-form
        @send="onSend"
        :attribute="selectedAttribute"
        :isCreate="isCreate"
      />
    </b-modal>
  </section>
</template>

<script>
import { ATTRIBUTES_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import debounce from 'lodash/debounce'
import AttributesForm from '@/components/mis/AttributesForm'
import AttributesRelationList from '@/components/mis/AttributesRelationList'

export default {
  name: 'Attributes',
  components: {
    AttributesRelationList,
    AttributesForm
  },
  data() {
    return {
      isLoading: false,
      sending: false,
      isFormModalActive: false,
      isCreate: false,

      searchName: '',
      attributes: [],
      selectedAttribute: null,

      total: 0,
      sortField: 'name',
      sortOrder: 'asc',
      defaultSortOrder: 'asc',
      page: 1,
      perPage: 10
    }
  },
  mounted() {
    this.loadAttributes()
  },
  methods: {
    async loadAttributes() {
      try {
        const api = `${ATTRIBUTES_API}`
        const params = {
          name: this.searchName,
          sort_by: this.sortField,
          by_descending: this.sortOrder !== 'asc',
          page_size: this.perPage,
          page_number: this.page
        }
        this.isLoading = true
        const res = await this.axios.get(api, { params })
        const data = res.data.data

        this.attributes = data.items
        this.total = data.item_count
      } catch (e) {
        this.attributes = []
        this.total = 0

        notifyService.fetch_error('attribute', e)
      } finally {
        this.isLoading = false
      }
    },
    onModify(item) {
      this.selectedAttribute = item
      this.isCreate = false
      this.isFormModalActive = true
    },
    showDetail(item) {
      this.selectedAttribute = item
    },
    onAdd() {
      this.selectedAttribute = {
        id: '',
        name: '',
        created_at: '',
        updated_at: ''
      }
      this.isCreate = true
      this.isFormModalActive = true
    },
    async onSend(item) {
      if (this.isCreate) {
        await this.onCreate(item)
      } else {
        await this.onUpdate(item)
      }
    },
    async onCreate(item) {
      try {
        const api = `${ATTRIBUTES_API}/create`

        this.sending = true
        await this.axios.post(api, item)
        notifyService.success(this.$t('attributes.add_succeed'))

        await this.loadAttributes()
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
        this.isFormModalActive = false
      }
    },
    async onUpdate(item) {
      try {
        const api = `${ATTRIBUTES_API}/update`

        this.sending = true
        await this.axios.put(api, item)
        notifyService.success(this.$t('attributes.update_succeed'))

        await this.loadAttributes()
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
        this.isFormModalActive = false
      }
    },
    onPageChange(page) {
      this.page = page

      this.loadAttributes()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order

      this.loadAttributes()
    },
    onSearch: debounce(function() {
      this.loadAttributes()
    }, 500)
  }
}
</script>
